import { render, staticRenderFns } from "./border-box.vue?vue&type=template&id=5c3bb022&lang=true&"
import script from "./border-box.vue?vue&type=script&lang=js&"
export * from "./border-box.vue?vue&type=script&lang=js&"
import style0 from "./border-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports